const base = {
  service: {
    route: "orders/ServiceFacade",
    title: "servicos",
    headers: [
      {title: "Código", field: "externalCode"},
      {title: "Nome", field: "name"},
      {title: "Critério", field: "criteria"},
      {title: "Tempo Padrão", field: "defaultTime"},
      {title: "Prioridade", field: "priority"},
      {title: "Tempo", field: "time"},
      {title: "Preço", field: "price"},
      {title: "Critério de Medida", field: "criterionOfMeasurement"},
      {title: "Pontos", field: "points"},
      {title: "Contrato", field: "idContract"},
      {title: "Descrição", field: "description"},
    ],
  },
  mos: {
    route: "orders/MosFacade",
    title: "mos",
    headers: [
      {title: "Código", field: "code"},
      {title: "Nome", field: "name"},
      {title: "Tipo de Conexão", field: "connectionType"},
      {title: "Medição Padrão", field: "standardMeasurement"},
      {title: "Critério de Medida", field: "criterionOfMeasurement"},
      {title: "Tipo", field: "type"},
      {title: "Preço", field: "price"},
      {title: "Pontos", field: "points"},
      {title: "Contrato", field: "idContract"},
    ],
  },
  itemClass: {
    route: "registry/ItemClassFacade",
    title: "classes-item",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  criterionOfMeasurement: {
    route: "registry/MeasurementUnitsFacade",
    title: "criterios-de-medida",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Símbolo", field: "symbol"},
      {title: "Descrição", field: "description"},
    ],
  },
  supplier: {
    route: "registry/SupplierFacade",
    title: "fornecedores",
    headers: [
      {title: "Nome", field: "name"},
      {title: "CNPJ", field: "cnpj"},
      {title: "CEP", field: "cep"},
      {title: "Endereço", field: "address"},
      {title: "Bairro", field: "neighborhood"},
      {title: "Cidade", field: "city"},
      {title: "E-mail", field: "email"},
      {title: "Telefone", field: "phoneNumber"},
    ],
  },
  itemTypeGroup: {
    route: "itemTypeGroup",
    title: "grupos-tipo-item",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  itemType: {
    route: "registry/ItemTypesFacade",
    title: "tipos-item",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  warehouse: {
    route: "warehouse/WarehouseFacade",
    title: "depositos",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Tipo", field: "typeName"},
      {title: "Endereço", field: "address"},
      {title: "Descrição", field: "description"},
      {title: "CEP", field: "cep"},
      {title: "Localidade", field: "localName"},
      {title: "Bairro", field: "neighborhood"},
      {title: "Id Origem", field: "idSource"},
    ],
  },
  itemWarehouse: {
    route: "warehouse/ItemWarehouseFacade",
    title: "itens-estoque",
    headers: [
      {title: "Cód", field: "id"},
      {title: "Item", field: "itemName"},
      {title: "Unidade", field: "criterionOfMeasurementName"},
      {title: "Quantidade", field: "quantity"},
      {title: "Depósito", field: "warehouseName"},
      {title: "Local Micro", field: "microLocationName"},
    ],
  },
  itemInventory: {
    route: "itemInventory",
    title: "itens-inventario",
    headers: [
      {title: "Item", field: "itemName"},
      {title: "Unidade", field: "criterionOfMeasurementSymbol"},
      {title: "Quantidade", field: "quantity"},
      {title: "Contagem", field: "count"},
      {title: "Acerto", field: "reckoning"},
      {title: "Inventário", field: "idInventory"},
    ],
  },
  inventory: {
    route: "warehouse/InventoryFacade",
    title: "inventarios",
    headers: [
      {title: "Código", field: "id"},
      {title: "Depósito", field: "warehouseName"},
      {title: "Tipo Inventário", field: "inventoryTypeName"},
      {title: "Modalidade", field: "modalityName"},
      {title: "Status", field: "statusName"},
      {title: "Data Início", field: "startDate"},
      {title: "Hora Início", field: "startTime"},
      {title: "Data Fim", field: "endDate"},
      {title: "Hora Fim", field: "endTime"},
      {title: "Funcionário", field: "employeeName"},
      {title: "Descrição", field: "description"},
      {title: "Observação", field: "observation"},
    ],
  },
  item: {
    route: "warehouse/ItemFacade",
    title: "itens",
    headers: [
      {title: "Código", field: "code"},
      {title: "Nome", field: "name"},
      {title: "Critério de Medida", field: "criterionOfMeasurementSymbol"},
      {title: "Tipo", field: "itemTypeName"},
      {title: "Classe", field: "itemClassName"},
      {title: "Quantidade Total", field: "quantity"},
      {title: "Preço", field: "price"},
      {title: "Baixo Uso", field: "isLowUsage", format: "activeInactive"},
    ],
  },
  movement: {
    route: "warehouse/MovementFacade",
    title: "movimentacoes",
    headers: [
      {title: "Cod", field: "id"},
      {title: "Tipo", field: "typeName"},
      {title: "Local Origem", field: "originName"},
      {title: "Local Destino", field: "destinationName"},
      {title: "Fornecedor", field: "supplierName"},
      {title: "Data", field: "date"},
      {title: "Nota Fiscal", field: "ntm"},
      {title: "Obra", field: "idConstructionProject"},
      {title: "Descrição", field: "description"},
      {title: "Número do pedido", field: "orderNumber"},
      {title: "Protocolo do pedido", field: "orderProtocol"},
      {title: "Tipo do pedido", field: "orderType"},
      {title: "Usuário", field: "userName"},
      {title: "Status", field: "status", format: "activeInactive"},
      {title: "Protocolo", field: "protocolo"},
    ],
  },
  itemMovement: {
    route: "warehouse/ItemMovementFacade",
    title: "itens-movimentacao",
    headers: [
      {title: "Código Item", field: "code"},
      {title: "Movimentação", field: "idMovement"},
      {title: "Quantidade", field: "quantity"},
      {title: "Tipo Movimentação", field: "typeName"},
      {title: "Data Movimentação", field: "date"},
      {title: "Preço Item", field: "price"},
      {title: "Depósito Destino", field: "destinationWarehouseName"},
      {title: "Fornecedor", field: "supplierName"},
    ],
  },
  base: {
    route: "registry/BasesFacade",
    title: "bases",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  contract: {
    route: "registry/ContractFacade",
    title: "contratos",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  district: {
    route: "registry/DistrictFacade",
    title: "distritos",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  local: {
    route: "registry/LocalFacade",
    title: "locais",
    headers: [
      {title: "Código", field: "id"},
      {title: "Unidade", field: "idUnity"},
      {title: "Nome", field: "name"},
    ],
  },
  resource: {
    route: "registry/ResourcesFacade",
    title: "recursos",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  workshop: {
    route: "vehicles/WorkshopFacade",
    title: "recursos",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Endereço", field: "address"},
      {title: "Bairro", field: "neighborhood"},
      {title: "Localidade", field: "localName"},
    ],
  },
  gasStation: {
    route: "vehicles/GasStationFacade",
    title: "postos-gasolina",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Endereço", field: "address"},
      {title: "Bairro", field: "neighborhood"},
      {title: "Localidade", field: "localName"},
    ],
  },
  serviceMaintenance: {
    route: "vehicles/ServiceMaintenanceFacade",
    title: "servicos-manutencao",
    headers: [{title: "Nome", field: "name"}],
  },
  chargeType: {
    route: "chargeType",
    title: "tipos-encargo",
    headers: [{title: "Nome", field: "name"}],
  },
  vehicleUseType: {
    route: "vehicles/VehicleUseTypeFacade",
    title: "tipos-uso-veiculo",
    headers: [{title: "Nome", field: "name"}],
  },
  vehicleType: {
    route: "vehicles/VehicleTypeFacade",
    title: "tipos-veiculo",
    headers: [{title: "Nome", field: "name"}],
  },
  vehiclesFuel: {
    route: "vehicles/VehicleFuelFacade",
    title: "combustiveis-veiculo",
    headers: [
      {title: "Placa", field: "licensePlate"},
      {title: "Posto", field: "gasStationName"},
      {title: "Data", field: "date"},
      {title: "Produto", field: "gasTypeName"},
      {title: "Condutor", field: "conductorName"},
      {title: "Quilometragem", field: "mileage"},
      {title: "Litros", field: "liters"},
      {title: "Valor", field: "value"},
    ],
  },
  vehiclesCharge: {
    route: "vehiclesCharge",
    title: "encargos-veiculo",
    headers: [
      {title: "Placa", field: "licensePlate"},
      {title: "Nome", field: "name"},
      {title: "Tipo", field: "typeName"},
      {title: "Data venc.", field: "endDate"},
      {title: "Valor", field: "value"},
      {title: "Condutor", field: "conductorName"},
      {title: "Recorrência", field: "recurrenceName"},
      {title: "Data Início", field: "startDate"},
      {title: "Data Fim", field: "endDate"},
      {title: "Status", field: "status", format: "activeInactive"},
      {title: "Observação", field: "observation"},
    ],
  },
  vehicleMaintenance: {
    route: "vehicleMaintenance",
    title: "manutencoes-veiculo",
    headers: [
      {title: "Prefixo", field: "id"},
      {title: "Placa", field: "licensePlate"},
      {title: "Data", field: "date"},
      {title: "Tipo", field: "typeLabel"},
      {title: "Oficina", field: "workshopName"},
      {title: "Serviço", field: "serviceName"},
      {title: "Status", field: "statusLabel"},
      {title: "Data de ínicio", field: "startDate"},
      {title: "Data Fim", field: "endDate"},
      {title: "Serviço", field: "serviceName"},
      {title: "Status", field: "statusLabel"},
      {title: "Tipo", field: "typeLabel"},
      {title: "Oficina", field: "workshopName"},
      {title: "Nota Fiscal", field: "nf"},
      {title: "Data de lançamento", field: "releaseDate"},
      {title: "Valor", field: "value"},
      {title: "Descrição", field: "description"},
    ],
  },
  vehicles: {
    route: "vehicles/VehicleFacade",
    title: "veiculos",
    headers: [
      {title: "Fabricante", field: "manufacturer"},
      {title: "Modelo", field: "model"},
      {title: "Placa", field: "licensePlate"},
      {title: "Condutor", field: "conductorName"},
      {title: "Contrato", field: "contractName"},
      {title: "Base", field: "baseName"},
      {title: "Localidade", field: "localName"},
      {title: "Chassis", field: "chassisNumber"},
      {title: "Cor", field: "color"},
      {title: "Última Manutenção", field: "lastMaintenanceDate"},
      {title: "Próxima Manutenção", field: "nextMaintenanceDate"},
      {title: "Notas", field: "notes"},
      {title: "Prefixo", field: "prefix"},
      {title: "Data de compra", field: "purchaseDate"},
      {title: "Fornecedor da compra", field: "purchaseSupplier"},
      {title: "Valor compra", field: "purchaseValue"},
      {title: "Renavam", field: "renavam"},
      {title: "Capacidade tanque", field: "tankCapacity"},
      {title: "Tipo de veículo", field: "vehicleTypeName"},
      {title: "Tipo de uso do veículo", field: "vehicleUseTypeName"},
      {title: "Ano de manufatura", field: "yearOfManufacture"},
      {title: "Ano do modelo", field: "yearOfModel"},
      {title: "Quilometragem", field: "mileage"},
      {title: "Status", field: "status", format: "status"},
    ],
  },
  vehiclesChecklist: {
    route: "vehiclesChecklist",
    title: "checklists-veiculo",
    headers: [
      {title: "Arquivo", field: "fileName"},
      {title: "Nome checklist", field: "name"},
      {title: "Data", field: "performedDate"},
      {title: "Veículo", field: "licensePlate"},
      {title: "Observação", field: "observation"},
    ],
  },
  vehiclesBaseContractLog: {
    route: "vehiclesBaseContractLog",
    title: "movimentacoes-veiculo",
    headers: [
      {title: "Data", field: "performedDate"},
      {title: "Contrato", field: "contractName"},
      {title: "Base", field: "baseName"},
      {title: "Veículo", field: "licensePlate"},
    ],
  },
  constructionProjectLog: {
    route: "constructionProjectLog",
    title: "historico-obra",
    headers: [
      {title: "Data", field: "performedDate", format: "datetime"},
      {title: "Código usuário", field: "idUser"},
      {title: "Usuário", field: "userName"},
      {title: "Ação", field: "actionName"},
      {title: "Protocolo Obra", field: "protocolo"},
      {title: "Observações", field: "observation"},
    ],
  },
  constructionProjectOs: {
    route: "constructionProjectOs",
    title: "protocolos-obra",
    headers: [
      {title: "Solicitado", field: "performedDate"},
      {title: "Protocolo", field: "protocolo"},
      {title: "Rua", field: "address"},
      {title: "Vencimento", field: "expirationDate"},
      {title: "Execução", field: "performedDate"},
      {title: "Tipo", field: "typeName"},
      {title: "Observações", field: "observation"},
    ],
  },
  emailSendingList: {
    route: "emailSendingList",
    title: "listas-envio-email",
    headers: [{title: "Nome", field: "name"}],
  },
  priceTable: {
    route: "construction/PriceTableFacade",
    title: "tabelas-preco",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  constructionProjectType: {
    route: "construction/ConstructionProjectTypeFacade",
    title: "tipos-obra",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  constructionUnitType: {
    route: "construction/ConstructionUnitTypeFacade",
    title: "tipos-unidade-construtiva",
    headers: [
      {title: "Código", field: "id"},
      {title: "Serviço", field: "name"},
      {title: "Valor ", field: "value"},
      {title: "Descrição ", field: "description"},
    ],
  },
  constructionProjectNoticeLog: {
    route: "constructionProjectNoticeLog",
    title: "historico-avisos-obra",
    headers: [
      {title: "Data", field: "sendDate"},
      {title: "Lista de Destino", field: "name", tableOrder: "emailSendingList"},
      {title: "Tipo de aviso", field: "type"},
      {title: "Protocolo da Obra", field: "protocolo"},
      {title: "Enviado por", field: "sendedByName"},
    ],
  },
  constructionUnit: {
    route: "constructionUnit",
    title: "unidades-construtivas",
    headers: [
      {title: "Lançamento", field: "id"},
      {title: "Tipo", field: "constructionUnitTypeName"},
      {title: "Funcionário", field: "employeeName"},
      {title: "Observações", field: "observation"},
      {title: "Quantidade", field: "quantity"},
      {title: "Quantidade Prevista", field: "expectedQuantity"},
      {title: "Medição", field: "measurementQuantity"},
      {title: "R$ / Quant", field: "quantityPrice"},
      {title: "Observação", field: "observation"},
    ],
  },
  constructionProject: {
    route: "construction/ConstructionProjectFacade",
    title: "obras",
    headers: [
      {title: "Id", field: "id"},
      {title: "Protocolo", field: "protocolo"},
      {title: "Rua", field: "address"},
      {title: "Bairro", field: "osNeighborhood"},
      {title: "Status", field: "statusName"},
      {title: "Data Solicitação", field: "requiredDate"},
      {title: "Data Início", field: "startDate"},
      {title: "Data Fim", field: "endDate"},
      {title: "Data Limite", field: "deadlineDate"},
      {title: "Data Conclusão", field: "conclusionDate"},
      {title: "Data Solicitação Licença", field: "licenseRequiredDate"},
      {title: "Mês Referência", field: "referenceMonth"},
      {title: "Mês Solicitação", field: "requiredMonth"},
      {title: "Tipo de obra", field: "constructionProjectTypeName"},
      {title: "Recurso", field: "resourceName"},
      {title: "Distrito", field: "districtName"},
      {title: "Contrato", field: "contractName"},
      {title: "Tabela de Preço", field: "priceTableName"},
      {title: "Localidade", field: "localityName"},
      {title: "Funcionário Monitor", field: "monitorName"},
      {title: "Funcionário Fiscal", field: "fiscalName"},
      {title: "Agilizar", field: "rushFlag", format: "activeInactive"},
      {title: "Licença", field: "licenseFlag", format: "activeInactive"},
      {title: "OSE", field: "oseFlag"},
      {title: "Rede", field: "networksFlag"},
      {title: "Permissão de Obra", field: "idConstructionPermit"},
      {title: "Excluída dia", field: "deletedAt", format: "datetime"},
    ],
  },
  rdo: {
    route: "rdo",
    title: "rdo",
    headers: [
      {title: "Código RDO", field: "id"},
      {title: "Data Envio", field: "performedDate"},
      {title: "Equipe", field: "teamName"},
      {title: "Observações", field: "observation"},
      {title: "Enviado por", field: "employeeName"},
      {title: "Unidade Construtiva", field: "idConstructionUnit"},
      {title: "Tipo", field: "type"},
    ],
  },
  rdoServicesMos: {
    route: "rdoServicesMos",
    title: "servicos-rdo",
    headers: [
      {title: "Código MOS", field: "idMos"},
      {title: "Serviço", field: "externalCode"},
      {title: "Funcionário", field: "employeeName"},
      {title: "Quantidade", field: "quantity"},
      {title: "Observações", field: "observation"},
      {title: "R$ Und", field: "price"},
      {title: "R$ Total", field: "totalPrice"},
      {title: "Pts Und", field: "points"},
      {title: "Pts Total", field: "totalPoints"},
    ],
  },
  materialRequest: {
    route: "materialRequest",
    title: "requisicoes-material",
    headers: [
      {title: "Código", field: "id"},
      {title: "Status", field: "statusName", orderField: "status"},
      {title: "Data", field: "requestedDate"},
      {title: "Obra", field: "idConstructionProject"},
      {title: "Solicitante", field: "originEmployeeName"},
      {title: "Funcionário", field: "employeeName"},
      {title: "CM", field: "warehouseOriginName"},
      {title: "Observações", field: "observation"},
    ],
  },
  materialRequestItem: {
    route: "materialRequestItem",
    title: "itens-requisicao-material",
    headers: [
      {title: "Depósito", field: "warehouseName"},
      {title: "Código Item", field: "idItem"},
      {title: "Material", field: "itemName"},
      {title: "UF", field: "criterionOfMeasurementName"},
      {title: "Solicitado", field: "requestedQuantity"},
      {title: "Em estoque", field: "stockQuantity"},
      {title: "Pendente", field: "pendingQuantity"},
      {title: "Data Solicit. Pedido", field: "requestedDate"},
      {title: "Status", field: "itemStatusName"},
    ],
  },
  emailSendingListEmployee: {
    route: "emailSendingListEmployee",
    title: "listas-envio",
    headers: [
      {title: "Nome", field: "employeeName"},
      {title: "Email", field: "email"},
    ],
  },
  employee: {
    route: "employee",
    title: "funcionarios",
    headers: [
      {title: "Registro", field: "registration"},
      {title: "Nome", field: "name"},
      {title: "Email", field: "email"},
      {title: "Apelido", field: "nickname"},
      {title: "Data de Nascimento", field: "dateOfBirth"},
      {title: "Gênero", field: "gender"},
      {title: "Estado Civil", field: "maritalStatus"},
      {title: "RG", field: "rg"},
      {title: "CTPS", field: "ctpsNumber"},
      {title: "CNH", field: "cnh"},
      {title: "CPF", field: "cpf"},
      {title: "PIS Pasep", field: "pisPasep"},
      {title: "Certidão de Nascimento", field: "birthCertificate"},
      {title: "Nacionalidade", field: "nationality"},
      {title: "Local de Nascimento", field: "birthPlace"},
      {title: "Data de Contratação", field: "hireDate"},
      {title: "Data de Demissão", field: "terminationDate"},
      {title: "Motivo de Demissão", field: "terminationReason"},
      {title: "Status", field: "status", format: "activeInactive"},
      {title: "Terceirizado", field: "outsourced", format: "activeInactive"},
      {title: "Cargo", field: "role"},
    ],
  },
  employeeCharge: {
    route: "employeeCharge",
    title: "encargos-funcionario",
    headers: [
      {title: "Salário", field: "salary"},
      {title: "Encargos", field: "charges"},
      {title: "Total", field: "total", disableOrder: true},
      {title: "Data Início", field: "startDate"},
      {title: "Data Fim", field: "endDate"},
      {title: "VR", field: "vr"},
      {title: "VA", field: "va"},
      {title: "VT", field: "vt"},
      {title: "SV", field: "sv"},
      {title: "Uniforme", field: "uniform"},
      {title: "EPI", field: "epi"},
      {title: "Assistência", field: "assistant"},
      {title: "Funcionário", field: "employeeName"},
    ],
  },
  email: {
    route: "employee",
    title: "emails",
    headers: [
      {title: "Nome", field: "name"},
      {title: "Email", field: "email"},
    ],
  },
  employeeRole: {
    route: "registry/EmployeeRoleFacade",
    title: "cargos-funcionario",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  teamType: {
    route: "hr/TeamTypeFacade",
    title: "tipos-equipe",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  team: {
    route: "teamDetails",
    title: "equipes",
    headers: [
      {title: "Código", field: "id"},
      {title: "Lider", field: "leaderName"},
      {title: "Veículo", field: "licensePlate"},
      {title: "Taxa Indireta", field: "indirectTax"},
      {title: "Meta Diária", field: "dailyMeta"},
    ],
  },
  paramBonificacao: {
    route: "paramBonificacao",
    title: "bonificacoes",
    headers: [
      {title: "Valor", field: "value"},
      {title: "Início", field: "startDate"},
      {title: "Fim", field: "endDate"},
    ],
  },
  paramDesconto: {
    route: "paramDesconto",
    title: "descontos",
    headers: [
      {title: "Valor", field: "value"},
      {title: "Início", field: "startDate"},
      {title: "Fim", field: "endDate"},
    ],
  },
  os: {
    route: "orders/OrdersFacade",
    title: "os",
    headers: [
      {title: "Unidade", field: "idUnity"},
      {title: "Local", field: "idLocale"},
      {title: "Distrito", field: "idDistrict"},
      {title: "Contrato", field: "idContract"},
      {title: "Equipe", field: "idTeam"},
      {title: "Serviço Solicitado", field: "idServiceRequested"},
      {title: "Serviço Realizado", field: "idServicePerformed"},
      {title: "Protocolo", field: "protocolo"},
      {title: "Tempo", field: "time"},
      {title: "Status", field: "status"},
      {title: "Rua", field: "address"},
      {title: "Número de endereço", field: "addressNumber"},
      {title: "Bairro", field: "neighborhood"},
      {title: "Odômetro Inicial", field: "startOdometer"},
      {title: "Odômetro Final", field: "endOdometer"},
      {title: "Data Realizada", field: "performedDate"},
      {title: "Data Solicitada", field: "requestedDate"},
      {title: "Data de Vencimento", field: "expirationDate"},
      {title: "CEP", field: "cep"},
      {title: "Observação", field: "observation"},
    ],
  },
  serviceGroup: {
    route: "registry/ServiceGroupFacade",
    title: "grupos-servico",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Descrição", field: "description"},
    ],
  },
  getGrouppedMaterialsOfRequest: {
    route: "getGrouppedMaterialsOfRequest",
    title: "materiais-requisicao",
    headers: [
      {title: "Qtd Req.", field: "requestsCount"},
      {title: "Código", field: "idItem"},
      {title: "Material", field: "itemName"},
      {title: "UF", field: "symbol"},
      {title: "Requisitado", field: "totalRequestedQuantity"},
      {title: "Retirado", field: "totalAppliedQuantity"},
      {title: "AS - Aplicado", field: "totalAsAppliedQuantity"},
      {title: "AS - Sobra", field: "totalAsRemainedQuantity"},
      {title: "AS - Falta", field: "totalAsMissingQuantity"},
    ],
  },
  getMeasureMaterial: {
    route: "getMeasureMaterial",
    title: "medicoes-material",
    headers: [
      {title: "Código", field: "idItem"},
      {title: "Material", field: "itemName"},
      {title: "Retirado", field: "totalWithdrawnQuantity"},
      {title: "UF", field: "uf"},
    ],
  },
  getMeasureOutsourced: {
    route: "getMeasureOutsourced",
    title: "medicoes-terceirizado",
    headers: [
      {title: "Nome externo", field: "outsourcedEmployeeName"},
      {title: "Serviço", field: "serviceName"},
      {title: "Qtd", field: "totalQuantity"},
      {title: "R$ Total", field: "totalPrice"},
      {title: "MOS", field: "idMos"},
      {title: "UF", field: "criterionOfMeasurement"},
      {title: "R$ Unitário", field: "price"},
    ],
  },
  getMeasure: {
    route: "getMeasure",
    title: "medicoes",
    headers: [
      {title: "Cód Mos", field: "idMos"},
      {title: "Serviço", field: "serviceName"},
      {title: "Qtd", field: "totalQuantity"},
      {title: "R$ Total", field: "totalValue"},
      {title: "Pontos unitários", field: "unitPoints"},
      {title: "Pontos total", field: "totalPoints"},
      {label: "UF", field: "uf"},
    ],
  },
  getMeasureProtocols: {
    route: "getMeasureProtocols",
    title: "medicoes-protocolo",
    headers: [
      {title: "Solicitado", field: "performedDate"},
      {title: "Protocolo", field: "protocolo"},
      {label: "Rua", field: "address"},
      {label: "Serviço", field: "serviceName"},
    ],
  },
  getMovementSanepar: {
    route: "report/getMovementSanepar",
    title: "movimentacoes-sanepar",
    headers: [
      {title: "Código do Item", field: "idItem"},
      {title: "Quantia Hidroleste", field: "totalQuantityHidroleste"},
      {title: "Quantia Sanepar", field: "totalQuantitySanepar"},
      {title: "Diferença", field: "difference"},
    ],
  },
  getActualStock: {
    route: "getActualStock",
    title: "estoque-atual",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "name"},
      {title: "Quantidade", field: "totalQuantity"},
    ],
  },
  getMovementHistory: {
    route: "getMovementHistory",
    title: "historico-movimentacoes",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "itemName"},
      {title: "Quantidade", field: "quantity"},
      {title: "Data", field: "date"},
      {title: "Usuário", field: "userName"},
    ],
  },
  getInventory: {
    route: "getInventory",
    title: "inventario",
    headers: [
      {title: "Cod", field: "id"},
      {title: "Data", field: "startDate"},
      {title: "Item", field: "itemName"},
      {title: "Quantidade em estoque do período", field: "quantity"},
      {title: "Contagem", field: "count"},
      {title: "Ajuste", field: "reckoning"},
    ],
  },
  dailyItemsByTeam: {
    route: "report/itemMovement",
    title: "itens-movimentacao",
    headers: [
      {title: "Tipo de Movimentação", field: "typeName", tableOrder: "movement"},
      {title: "Item", field: "idItem", tableOrder: "itemMovement"},
      {title: "Quantidade Entregue", field: "quantity", tableOrder: "itemMovement"},
      {title: "Quantidade Limite", field: "itemLimit", disableOrder: true},
      {title: "Id da Obra", field: "idObra", tableOrder: "movement"},
      {title: "Descrição", field: "description", tableOrder: "movement"},
    ],
  },
  getItensPerWarehouse: {
    route: "getItensPerWarehouse",
    title: "itens-por-deposito",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "name"},
      {title: "Quantidade", field: "quantity"},
    ],
  },
  getItensPerTeam: {
    route: "getItensPerTeam",
    title: "itens-por-equipe",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "itemName"},
      {title: "Depósito", field: "warehouseName"},
      {title: "Quantidade", field: "quantity"},
    ],
  },
  getEntryItensPerNF: {
    route: "getEntryItensPerNF",
    title: "entradas-itens-por-nf",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "itemName"},
      {title: "Quantidade", field: "quantity"},
      {title: "Data", field: "date"},
      {title: "Depósito", field: "warehouseName"},
    ],
  },
  getItensPerProtocol: {
    route: "getItensPerProtocol",
    title: "itens-por-protocolo",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "itemName"},
      {title: "Quantidade", field: "quantity"},
      {title: "Protocolo", field: "performedProtocol"},
      {title: "Depósito", field: "warehouseName"},
      {title: "Equipe", field: "teamName"},
      {title: "Endereço", field: "address"},
    ],
  },
  getCurrentBalance: {
    route: "getCurrentBalance",
    title: "saldo-atual",
    headers: [
      {title: "ID Item", field: "idItem"},
      {title: "Nome do Item", field: "name"},
      {title: "Quantidade de entrada", field: "totalQuantityEntry"},
      {title: "Quantidade de baixa", field: "totalQuantityDownward"},
      {title: "Saldo", field: "balance"},
    ],
  },
  getOsTeamComparative: {
    route: "getOsTeamComparative",
    title: "comparativo-os-equipe",
    headers: [
      {title: "Equipe", field: "idTeam"},
      {title: "Nome", field: "name"},
      {title: "Quantidade", field: "teamCount"},
    ],
  },
  getOsTeam: {
    route: "getOsTeam",
    title: "os-equipe",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Equipe", field: "idTeam", disableOrder: true},
      {title: "Data de realização", field: "performedDate"},
      {title: "Endereço", field: "address"},
    ],
  },
  getTeamPoints: {
    route: "reports/HumanResourceReportFacade",
    title: "pontos-equipe",
    headers: [
      {title: "Equipe", field: "idTeam", tableOrder: "osMedicao"},
      {title: "Nome", field: "name", tableOrder: "team"},
      {title: "Pontos Serviço", field: "servicePoints"},
      {title: "Pontos MOS", field: "mosPoints"},
      {title: "Total", field: "totalPoints"},
      {title: "Meta", field: "meta"},
    ],
  },
  itensPerProtocolReport: {
    route: "reports/WarehouseReportFacade",
    title: "itens-por-protocolo",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Data", field: "performedDate"},
      {title: "Quantidade", field: "totalQuantity"},
    ],
  },
  getFinancial: {
    route: "getFinancial",
    title: "financeiro",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Serviços", field: "valueServices"},
      {title: "MOS", field: "valueMos"},
      {title: "Valor Total", field: "total"},
    ],
  },
  getVehiclesCost: {
    route: "getVehiclesCost",
    title: "custos-veiculos",
    headers: [
      {title: "Placa", field: "licensePlate", tableOrder: "vehicles"},
      {title: "Modelo", field: "model", tableOrder: "vehicles"},
      {title: "Valor Encargos", field: "totalCharge"},
      {title: "Valor Combustível", field: "totalFuel"},
      {title: "Custo Total", field: "totalCosts"},
    ],
  },
  getVehicleHistory: {
    route: "report/getVehicleHistory",
    title: "historico-veiculos",
    headers: [
      {title: "Fabricante", field: "manufacturer"},
      {title: "Modelo", field: "model"},
      {title: "Placa", field: "licensePlate"},
      {title: "Proprietário", field: "ownerName"},
      {title: "Valor Encargo", field: "chargeValue"},
      {title: "Valor Combustível", field: "fuelValue"},
    ],
  },
  getOsComparative: {
    route: "getOsComparative",
    title: "comparativo-os",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Equipe", field: "idTeam"},
      {title: "Data", field: "performedDate"},
      {title: "Serviço Requisitado", field: "idServiceRequested"},
      {title: "Total Serviço", field: "jobValue", format: "float"},
      {title: "Total Deslocamento", field: "deslocamento", format: "float"},
      {title: "Total Glosa", field: "osGlosaTotal", format: "float"},
      {title: "Total Esperado", field: "esperado", format: "float"},
      {title: "Total Medição", field: "osMedicaoTotal", format: "float"},
      {title: "", field: "sinaleiro"},
    ],
  },
  getGlosa: {
    route: "getGlosa",
    title: "glosas",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Equipe", field: "idTeam"},
      {title: "Serviço Solicitado", field: "idServiceRequested"},
      {title: "Serviços realizados", field: "servicosRealizados"},
      {title: "V. glosado", field: "valorGlosado", format: "float"},
      {title: "V. total", field: "valorTotal", format: "float"},
      {title: "Observação", field: "observation"},
    ],
  },
  exportOsItemsTotal: {
    route: "report/exportOsItemsTotal",
    title: "os-itens-total",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Endereço", field: "address"},
      {title: "Item", field: "idItem"},
      {title: "Quantidade", field: "itemQuantity"},
      {title: "Descrição", field: "description"},
    ],
  },
  getOsRetroative: {
    route: "getOsRetroative",
    title: "os-retroativos",
    headers: [
      {title: "Protocolo", field: "protocolo"},
      {title: "Serviço", field: "externalCode"},
      {title: "Vencimento", field: "expireDate"},
      {title: "SLA", field: "time"},
      {title: "Equipe", field: "idTeam"},
      {title: "Endereço", field: "address"},
      {title: "Observação", field: "observation"},
      {title: "Status atual", field: "status"},
      {title: "Análise", field: "analise", format: "activeInactive"},
    ],
  },
  getProductivityReport: {
    route: "getProductivityReport",
    title: "produtividade",
    headers: [
      {title: "Equipe", field: "id"},
      {title: "Serviços", field: "countService"},
      {title: "Pontos", field: "points"},
      {title: "Meta", field: "dailyMeta"},
      {title: "Total Indireto", field: "totalIndireto", format: "float"},
      {title: "Total", field: "totalValue", format: "float"},
      {title: "Status", field: "status", format: "activeInactive"},
    ],
  },
  getOsQuantity: {
    route: "getOsQuantity",
    title: "quantidade-os",
    headers: [
      {title: "Serviço", field: "idServiceRequested"},
      {title: "Nome", field: "name"},
      {title: "Total", field: "totalRequests"},
    ],
  },
  getGroupByService: {
    route: "orders/OrdersFacade",
    title: "os-por-servico",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Quantidade", field: "quantity"},
    ],
  },
  getServiceGroupByPeriod: {
    route: "osService",
    title: "servicos-por-periodo",
    headers: [
      {title: "Código", field: "id"},
      {title: "Nome", field: "name"},
      {title: "Quantidade", field: "quantity"},
    ],
  },
  getMosGroupByPeriod: {
    route: "osMos",
    title: "mos-por-periodo",
    headers: [
      {title: "Código", field: "id"},
      {title: "Serviço", field: "idService"},
      {title: "Nome", field: "name"},
      {title: "Quantidade 1", field: "quantity1"},
      {title: "Quantidade 2", field: "quantity2"},
      {title: "Quantidade 3", field: "quantity3"},
      {title: "Total", field: "total"},
    ],
  },
  searchAllMovementsByWarehouse: {
    route: "warehouse/ItemMovementFacade/searchAllMovementsByWarehouse",
    title: "itens-estoque",
    headers: [
      {title: "Código", field: "id"},
      {title: "Item", field: "code"},
      {title: "Quantidade", field: "quantity"},
      {title: "Depósito Origem", field: "originName"},
      {title: "Depósito Destino", field: "destinationName"},
      {title: "Data", field: "date"},
      {title: "Observação", field: "observation"},
    ],
  },
  dashboard: {
    route: "getDailyOrders",
    title: "dashboard",
    headers: [
      {title: "Equipe", field: "idTeam"},
      {title: "Serviço", field: "idServiceRequested"},
      {title: "Protocolo", field: "protocolo"},
      {title: "Endereço", field: "address"},
      {title: "Local", field: "idLocale"},
      {title: "Distrito", field: "idDistrict"},
      {title: "Prioridade", field: "servicePriority"},
      {title: "Status", field: "status"},
      {title: "Andamento", field: "progress"},
      {title: "Vencimento", field: "expirationDate", format: "datetime"},
    ],
  },
}

export default base
